import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {Button, Card, DatePicker, Form, notification} from 'antd';

import {getPurchaseOrder, receivePurchaseOrder} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ReceivePurchaseOrderForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.purchaseId !== this.props.match.params.purchaseId) {
      this._load();
    }
  }

  _load = () => {
    const {purchaseId} = decodeParams(this.props.match.params);
    this.props.getPurchaseOrder({purchaseId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {purchaseId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.receivePurchaseOrder({...values, purchaseId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, purchaseOrder} = this.props;
    return (
      <Card title="Receive Purchase Order">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Purchase Order"
          >
            {`${purchaseOrder.supplierName} - ${purchaseOrder.status} (${purchaseOrder.modifiedAt})`}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Received Date"
          >
            {getFieldDecorator('receivedDate', {
              initialValue: moment(),
              rules: [
                { required: true, message: 'Please input your Received Date' },
              ]
            })(
              <DatePicker />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Receive Purchase Order
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

ReceivePurchaseOrderForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  receivePurchaseOrder: PropTypes.func.isRequired,
  getPurchaseOrder: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
};

const ReceivePurchaseOrderPage = Form.create()(ReceivePurchaseOrderForm);

const mapStateToProps = state => ({
  loading: state.purchaseOrder.purchaseOrderLoading || state.purchaseOrder.receivePurchaseOrderLoading,
  purchaseOrder: state.purchaseOrder.purchaseOrder || {},
});

const mapDispatchToProps = dispatch => ({
  receivePurchaseOrder: payload => (dispatch(receivePurchaseOrder(payload))),
  getPurchaseOrder: payload => (dispatch(getPurchaseOrder(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceivePurchaseOrderPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/ReceivePurchaseOrderPage.js